export default function Bar() {
  return (
    <section id="bar" className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-br from-[#4A7C59] via-[#3d6849] to-[#4A7C59] relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-64 h-64 bg-[#FF8F6B] rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#F5E6D3] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Title */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block bg-white/20 glass text-white px-4 md:px-8 py-2 md:py-3 rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6 whitespace-nowrap">
            AMBIANCE CHILL 🌴
          </div>
          
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-black text-white mb-3 md:mb-4 px-4" style={{ fontFamily: 'Pacifico, cursive' }}>
            Le Bar
          </h2>
          
          <p className="text-lg md:text-2xl text-white/90 font-semibold flex flex-wrap items-center justify-center gap-2 md:gap-3 px-4">
            <span className="text-3xl md:text-4xl animate-wiggle">🍹</span>
            <span>Cocktails, Mocktails & Frappuccinos</span>
            <span className="text-3xl md:text-4xl animate-wiggle" style={{ animationDelay: '0.5s' }}>🥥</span>
          </p>
        </div>

        {/* Introduction Text */}
        <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16 px-4">
          <p className="text-white text-lg md:text-2xl font-bold leading-relaxed">
            Vivez une expérience unique sur l'île avec notre bar créatif ! 
            Découvrez nos cocktails signatures exclusifs, créez votre propre cocktail avec nos barmans experts, 
            et explorez nos spiritueux fumés introuvables ailleurs. 
            Une aventure gustative qui vous attend au Bocal Givré.
          </p>
        </div>

        {/* Bento Grid - 3 Concepts */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          
          {/* Concept 1: Cocktails Signatures */}
          <div className="rounded-2xl md:rounded-3xl bg-gradient-to-br from-[#FF8F6B] to-[#ff6b47] p-6 md:p-8 shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer border-2 md:border-4 border-white/20">
            <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
              <span className="text-4xl md:text-5xl">🍹</span>
              <h3 className="text-white text-2xl md:text-3xl font-black">Cocktails Signatures</h3>
            </div>
            
            <p className="text-white/95 font-semibold text-base md:text-lg mb-4">
              Chaque semaine, découvrez nos créations uniques que vous ne trouverez nulle part ailleurs :
            </p>
            
            <div className="space-y-3 md:space-y-4">
              <div className="bg-white/20 glass rounded-lg md:rounded-xl p-3 md:p-4 hover:bg-white/30 transition-colors">
                <p className="text-white font-bold text-base md:text-lg flex items-center gap-2 md:gap-3">
                  <span className="text-xl md:text-2xl">☕</span> Le Gourmand
                </p>
                <p className="text-white/80 text-xs md:text-sm mt-1">Noisettes, café & douceur</p>
              </div>
              
              <div className="bg-white/20 glass rounded-lg md:rounded-xl p-3 md:p-4 hover:bg-white/30 transition-colors">
                <p className="text-white font-bold text-base md:text-lg flex items-center gap-2 md:gap-3">
                  <span className="text-xl md:text-2xl">🌿</span> Le Frais
                </p>
                <p className="text-white/80 text-xs md:text-sm mt-1">Ginger, hibiscus & fraîcheur</p>
              </div>
              
              <div className="bg-white/20 glass rounded-lg md:rounded-xl p-3 md:p-4 hover:bg-white/30 transition-colors">
                <p className="text-white font-bold text-base md:text-lg flex items-center gap-2 md:gap-3">
                  <span className="text-xl md:text-2xl">🥭</span> L'Exotique
                </p>
                <p className="text-white/80 text-xs md:text-sm mt-1">Passion, mangue & évasion</p>
              </div>
            </div>
          </div>

          {/* Concept 2: Atelier Création */}
          <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group cursor-pointer relative border-2 md:border-4 border-white/20 hover:border-[#F5E6D3] transition-colors h-[500px] md:h-auto">
            <div className="w-full h-full">
              <img 
                src="https://static.readdy.ai/image/d4c222fca79cec1b33ab7f1e22d0ce93/2c6359e077529c8fda03dbfbb68c3fd8.png" 
                alt="Atelier Création Cocktails"
                className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#4A7C59]/95 via-[#4A7C59]/60 to-transparent flex items-end p-6 md:p-8">
              <div className="w-full">
                <p className="text-white text-2xl md:text-3xl font-black mb-2 md:mb-3">Atelier Création</p>
                <p className="text-[#F5E6D3] text-base md:text-lg font-bold mb-2">
                  "Composez-le, buvez-le, nommez-le !"
                </p>
                <p className="text-white/90 text-sm md:text-base font-semibold">
                  Sur les conseils de nos barmans experts
                </p>
              </div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute top-4 right-4 md:top-6 md:right-6 bg-[#FF8F6B] text-white px-4 py-2 md:px-6 md:py-3 rounded-full font-black text-sm md:text-base shadow-xl animate-pulse-glow">
              UNIQUE
            </div>
          </div>

          {/* Concept 3: Spiritueux Uniques */}
          <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group cursor-pointer relative h-[500px] md:h-auto border-2 md:border-4 border-white/20 hover:border-[#F5E6D3] transition-colors">
            <div className="w-full h-full">
              <img 
                src="https://static.readdy.ai/image/d4c222fca79cec1b33ab7f1e22d0ce93/54591b057e4beb1465ed601113f3c6b9.jpeg" 
                alt="Spiritueux Fumés Uniques"
                className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#4A7C59]/95 via-[#4A7C59]/60 to-transparent flex items-end p-6 md:p-8">
              <div className="w-full">
                <p className="text-white text-2xl md:text-3xl font-black mb-2 md:mb-3">Spiritueux Uniques</p>
                <p className="text-[#F5E6D3] text-base md:text-lg font-bold">
                  Découvrez nos spiritueux exclusifs de l'île
                </p>
                <p className="text-white/90 text-sm md:text-base font-semibold mt-2">
                  Une expérience fumée inoubliable
                </p>
              </div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute top-4 right-4 md:top-6 md:right-6 bg-[#FF8F6B] text-white px-4 py-2 md:px-6 md:py-3 rounded-full font-black text-sm md:text-base shadow-xl animate-pulse-glow">
              EXCLUSIF
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
